import http from '../../helpers/http-common';
import { IAxiosResponseCustom } from './../../models/http.model';

export const baseCount = (resourceURL: string) => {
  return {
    count: (): Promise<IAxiosResponseCustom> =>
      http.get(`${resourceURL}/count`),
  };
};
